<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="queryParams" :model="queryParams" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="商家账号：" prop="userName">
                <el-select
                  v-if="role != 'agent'"
                  clearable
                  size="small"
                  v-model="queryParams.userName"
                  filterable
                >
                  <template v-for="(value, key) in accountList">
                    <el-option
                      :key="value.userName"
                      :label="
                        `${value.userName}${
                          value.nickName ? '(' + value.nickName + ')  ' : ''
                        }`
                      "
                      :value="value.userName"
                    ></el-option>
                  </template>
                </el-select>
                <el-input
                  v-else
                  size="small"
                  v-model="queryParams.userName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机号：" prop="phoneNumber">
                <el-input
                  size="small"
                  v-model="queryParams.phoneNumber"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="主账号：" prop="createBy">
                <el-input
                  size="small"
                  v-model="queryParams.createBy"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="账号类型：" prop="userType">
                <el-select
                  style="width: 100%"
                  clearable
                  size="small"
                  v-model="queryParams.userType"
                >
                  <template v-for="(value, key) in dictData['user_type']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="账号状态：" prop="status">
                <el-select
                  style="width: 100%"
                  clearable
                  size="small"
                  v-model="queryParams.status"
                >
                  <template
                    v-for="(value, key) in dictData['sys_normal_disable']"
                  >
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商家等级：" prop="gear">
                <el-select
                  style="width: 100%"
                  clearable
                  size="small"
                  v-model="queryParams.gear"
                >
                  <template v-for="(value, key) in dictData['gear']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item style="width: 100%" label="注册时间：" prop="time">
                <el-date-picker
                  size="small"
                  v-model="time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="VIP等级：" prop="gear">
                <el-select
                  style="width: 100%"
                  clearable
                  size="small"
                  v-model="queryParams.vipType"
                >
                  <template v-for="(value, key) in dictData['vipType']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="邀请人：" prop="inviter">
                <el-input
                  size="small"
                  v-model="queryParams.inviter"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="渠道：" prop="channel">
                <el-select
                  style="width: 100%"
                  clearable
                  size="small"
                  v-model="queryParams.channel"
                >
                  <template v-for="(value, key) in dictData['CHANNEL']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />

      <el-table :data="tableData" border>
        <el-table-column
          width="169"
          label="注册时间"
          prop="createTime"
        ></el-table-column>

        <el-table-column label="商家账号" prop="userName"> </el-table-column>
        <el-table-column label="主账号" prop="createBy"></el-table-column>
        <el-table-column
          width="112"
          label="手机号"
          prop="phoneNumber"
        ></el-table-column>
        <el-table-column label="商家姓名" prop="nickName"></el-table-column>
        <el-table-column label="邀请人" prop="inviter"></el-table-column>
        <el-table-column label="渠道" prop="channel">
          <template slot-scope="scope">
            <div>{{ dictMap["CHANNEL"][scope.row.channel] }}</div>
          </template>
        </el-table-column>
        <el-table-column width="100" label="账号类型" prop="user_type">
          <template slot-scope="scope">
            <div>{{ dictMap["user_type"][scope.row.userType] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="账号状态" prop="status">
          <template slot-scope="scope">
            <div>{{ scope.row.status == "1" ? "正常" : "停用" }}</div>
          </template>
        </el-table-column>
        <el-table-column label="余额" prop="">
          <template slot-scope="scope">
            <div>{{ scope.row.balance }}</div>
          </template>
        </el-table-column>
        <el-table-column label="商家等级" prop="">
          <template slot-scope="scope">
            <div>{{ dictMap["gear"][scope.row.gear] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="VIP等级" prop="">
          <template slot-scope="scope">
            <div>{{ dictMap["vipType"][scope.row.vipType] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="已免费使用(M)" prop="">
          <template slot-scope="scope">
            <div>{{ scope.row.usedSpace }}</div>
          </template>
        </el-table-column>
        <el-table-column label="总付费容量(M)" prop="">
          <template slot-scope="scope">
            <div>{{ scope.row.totalSpace }}</div>
          </template>
        </el-table-column>
        <el-table-column label="已付费使用(M)" prop="">
          <template slot-scope="scope">
            <div>{{ scope.row.feeUsedSpace }}</div>
          </template>
        </el-table-column>
        <el-table-column label="剩余付费容量(M)" prop="">
          <template slot-scope="scope">
            <div>{{ scope.row.leftSpace }}</div>
          </template>
        </el-table-column>
        <el-table-column label="微信" prop="wechat"></el-table-column>
        <el-table-column label="邮箱" prop="email"></el-table-column>
        <el-table-column label="公司" prop="company"></el-table-column>

        <el-table-column
          label="最近登录时间"
          prop="loginDate"
          width="169"
        ></el-table-column>
        <el-table-column
          v-if="role != 'agent'"
          width="60"
          fixed="right"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.row)"
              >修改</el-button
            ></template
          >
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="商家修改"
      :visible.sync="dialogVisible"
    >
      <div>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          size="small"
          label-width="160px"
        >
          <el-form-item label="商家账号：">
            {{ form.userName }}
          </el-form-item>
          <el-form-item label="账号类型：">
            {{ dictMap["user_type"][form.userType] }}</el-form-item
          >
          <el-form-item label="手机号：" prop="phoneNumber">
            <el-input v-model="form.phoneNumber" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="商家姓名：" prop="nickName">
            <el-input v-model="form.nickName" placeholder=""></el-input>
          </el-form-item>
          <el-form-item v-if="form.userType !== '02'" label="商家等级" prop="">
            <el-select clearable v-model="form.gear">
              <template v-for="(value, key) in dictData['gear']">
                <el-option
                  :key="key"
                  :label="value.label"
                  :value="value.value"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item v-if="form.userType !== '02'" label="VIP等级" prop="">
            <el-select clearable v-model="form.vipType">
              <template v-for="(value, key) in dictData['vipType']">
                <el-option
                  :key="key"
                  :label="value.label"
                  :value="value.value"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="微信：" prop="wechat">
            <el-input v-model="form.wechat" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="邮箱：" prop="email">
            <el-input v-model="form.email" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="公司：" prop="company">
            <el-input v-model="form.company" placeholder=""></el-input>
          </el-form-item>
          <el-form-item
            v-if="form.userType == '01'"
            label="图库容量（增加）："
            prop="company"
          >
            <el-input
              :placeholder="`当前值${form.totalSpace}`"
              v-model="form.totalSpaceAdd"
            ></el-input
            ><br />
          </el-form-item>
          <el-form-item
            v-if="form.userType == '01'"
            label="设计次数（增加）："
            prop="company"
          >
            <el-input
              :placeholder="`当前值${form.allDesignNum}`"
              v-model="form.allDesignNumAdd"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="form.userType == '01'"
            label="店铺数量（增加）："
            prop="company"
          >
            <el-input
              :placeholder="`当前值${form.allShopNum}`"
              v-model="form.allShopNumAdd"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="form.userType == '01'"
            label="子账号数量（增加）："
            prop="company"
          >
            <el-input
              :placeholder="`当前值${form.allAccountNum}`"
              v-model="form.allAccountNumAdd"
            ></el-input>
          </el-form-item>
          <el-form-item label="账号状态：" prop="status">
            <el-radio-group v-model="form.status">
              <template>
                <el-radio label="1" key="1">正常</el-radio>
                <el-radio label="0" key="0">停用</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleSave"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import { listUser, editUser } from "@/api/business/merchantManage"
import { listInvite } from "@/api/system/user"

export default {
  components: { Breadcrumb },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 50,
        beginTime: undefined,
        endTime: undefined,
        phoneNumber: undefined,
        userType: "01",
        status: undefined,
        userName: "",
        createBy: "",
        gear: "",
        vipType: "",
        inviter: "",
        channel: "",
      },
      time: [],
      total: 0,
      tableData: [],
      rules: {},
      dialogVisible: false,
      form: { userExt: {} },
      accountList: [],
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
    role() {
      return this.$store.state.user.roles[0]
    },
  },
  created() {
    // let curDate = new Date()
    // let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

    // this.time = [
    //   this.parseTime(preDate, "{y}-{m}-{d}"),
    //   this.parseTime(curDate, "{y}-{m}-{d}"),
    // ]
    this.loadData()
    this.getAccountList()
  },
  methods: {
    /* 获取列表数据 */
    async getAccountList() {
      let result = await listUser({
        pageNum: 1,
        pageSize: 100000,
        userType: "01",
      })
      this.accountList = result.rows
    },
    loadData() {
      this.startLoading()
      let params = JSON.parse(JSON.stringify(this.queryParams))

      if (this.time && this.time.length > 0) {
        params.beginTime = this.time[0]
        params.endTime = this.time[1]
      } else {
        params.beginTime = undefined
        params.endTime = undefined
      }
      let loadMethod = listUser
      if (this.role == "agent") {
        loadMethod = listInvite
      }

      loadMethod(params)
        .then((res) => {
          this.endLoading()
          this.total = res.total
          this.tableData = res.rows
        })
        .catch((err) => {
          this.endLoading()
          console.error(err)
        })
    },
    resetForm() {
      this.$refs["queryParams"].resetFields()
    },
    /* 下载数据 */
    handleEdit(row) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs["form"].resetFields()
        if (row.userId) {
          row.totalSpaceAdd = "0"
          row.allAccountNumAdd = "0"
          row.allShopNumAdd = "0"
          row.allDesignNumAdd = "0"
          this.form = Object.assign({}, row)
          this.dialogTitle = "修改"
        } else {
          this.form = {}
          this.dialogTitle = "新增"
        }
      })
    },
    handleSave() {
      let _self = this
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let form = this._.clone(_self.form)
          form.status = form.status ? "1" : "0"

          form.totalSpace = ""
          form.allAccountNum = ""
          form.allShopNum = ""
          form.allDesignNum = ""

          if (form.totalSpaceAdd) {
            form.totalSpace = form.totalSpaceAdd
          }
          if (form.allAccountNumAdd) {
            form.allAccountNum = form.allAccountNumAdd
          }
          if (form.allShopNumAdd) {
            form.allShopNum = form.allShopNumAdd
          }
          if (form.allDesignNumAdd) {
            form.allDesignNum = form.allDesignNumAdd
          }

          if (_self.form.userId) {
            editUser(form).then((response) => {
              if (response.code == "200") {
                _self.msgSuccess("修改成功！")
                _self.dialogVisible = false
                _self.loadData()
              } else {
                _self.msgError("修改失败！")
              }
            })
          } else {
            // addVar(_self.form).then((response) => {
            //   if (response.code === 200) {
            //     _self.msgSuccess('新增成功！')
            //     _self.dialogVisible = false
            //     _self.loadData()
            //   } else {
            //     _self.msgError('新增失败！')
            //   }
            // })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
</style>
